import { useDispatch } from 'react-redux';
import { debounce } from 'lodash';
import { getAggregationsAction, getList } from '../../containers/App/actions';
import { PAGINATION_DEFAULT_LIMIT, performancesAggregationTypes } from '../../constants/consts';
import { PRODUCTIONS, PRODUCTIONS_AGGREGATIONS } from '../../constants/endpointConstants';
import { getSearchProductionsAction } from '../../containers/Artist/actions';

export default function useProductionsMethods(profileId, resetProduction) {
  const dispatch = useDispatch();
  const getProductions = (pagination, query = {}) => {
    dispatch(
      getList({
        endpoint: PRODUCTIONS,
        sagaRoutine: getSearchProductionsAction,
        params: {
          queryParams: {
            [performancesAggregationTypes.profileAgg]: profileId,
            sort: '-year',
            as_edit: true,
            published: true,
            ...query,
          },
          pagination,
        },
      }),
    );
  };
  const isProductionRecordCheck = isProductionRecord => {
    if (isProductionRecord) {
      getProductions({ limit: PAGINATION_DEFAULT_LIMIT, page: 1 });
    } else {
      resetProduction();
    }
  };
  const searchProductions = debounce(v => {
    dispatch(
      getAggregationsAction({
        endpoint: PRODUCTIONS_AGGREGATIONS,
        query: {
          [performancesAggregationTypes.typeAgg]: performancesAggregationTypes.workAgg,
          [performancesAggregationTypes.profileAgg]: profileId,
          [performancesAggregationTypes.queryAgg]: v,
          published: true,
        },
        fieldName: 'production-search',
      }),
    );
  }, 300);

  return {
    isProductionRecordCheck,
    getProductions,
    searchProductions,
  };
}
